module.exports = __webpack_public_path__ + "img/ry_6.01e8dccb.png";